var map = {
	"./advanced-forms/advanced-forms.module": [
		"./src/app/views/forms/advanced-forms/advanced-forms.module.ts",
		"default~advanced-forms-advanced-forms-module~basic-forms-basic-forms-module~dashboards-dashboards-mo~b682605c",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-base-base-module",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-notifications-notifi~51f09f6f",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-dashboard-dashboard-~f8b7fa5d",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module",
		"common",
		"advanced-forms-advanced-forms-module"
	],
	"./basic-forms/basic-forms.module": [
		"./src/app/views/forms/basic-forms/basic-forms.module.ts",
		"default~advanced-forms-advanced-forms-module~basic-forms-basic-forms-module~dashboards-dashboards-mo~b682605c",
		"common",
		"basic-forms-basic-forms-module"
	],
	"./calendar/calendar.module": [
		"./src/app/views/plugins/calendar/calendar.module.ts",
		"calendar-calendar-module"
	],
	"./code-editors/code-editors.module": [
		"./src/app/views/editors/code-editors/code-editors.module.ts",
		"code-editors-code-editors-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"default~advanced-forms-advanced-forms-module~basic-forms-basic-forms-module~dashboards-dashboards-mo~b682605c",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-base-base-module",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-notifications-notifi~51f09f6f",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-dashboard-dashboard-~f8b7fa5d",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module",
		"default~dashboards-dashboards-module~toastr-toastr-module",
		"default~dashboards-dashboards-module~loading-buttons-loading-buttons-module",
		"common",
		"dashboards-dashboards-module"
	],
	"./datatable/datatable.module": [
		"./src/app/views/tables/datatable/datatable.module.ts",
		"datatable-datatable-module"
	],
	"./draggable-cards/draggable-cards.module": [
		"./src/app/views/plugins/draggable-cards/draggable-cards.module.ts",
		"draggable-cards-draggable-cards-module"
	],
	"./email/email.module": [
		"./src/app/views/apps/email/email.module.ts",
		"email-email-module"
	],
	"./invoicing/invoice.module": [
		"./src/app/views/apps/invoicing/invoice.module.ts",
		"invoicing-invoice-module"
	],
	"./loading-buttons/loading-buttons.module": [
		"./src/app/views/buttons/loading-buttons/loading-buttons.module.ts",
		"default~dashboards-dashboards-module~loading-buttons-loading-buttons-module",
		"common",
		"loading-buttons-loading-buttons-module"
	],
	"./spinners/spinners.module": [
		"./src/app/views/plugins/spinners/spinners.module.ts",
		"spinners-spinners-module"
	],
	"./text-editors/text-editors.module": [
		"./src/app/views/editors/text-editors/text-editors.module.ts",
		"text-editors-text-editors-module"
	],
	"./toastr/toastr.module": [
		"./src/app/views/notifications/toastr/toastr.module.ts",
		"default~dashboards-dashboards-module~toastr-toastr-module",
		"common",
		"toastr-toastr-module"
	],
	"./validation-forms/validation-forms.module": [
		"./src/app/views/forms/validation-forms/validation-forms.module.ts",
		"validation-forms-validation-forms-module"
	],
	"./views/apps/apps.module": [
		"./src/app/views/apps/apps.module.ts",
		"views-apps-apps-module"
	],
	"./views/base/base.module": [
		"./src/app/views/base/base.module.ts",
		"default~advanced-forms-advanced-forms-module~basic-forms-basic-forms-module~dashboards-dashboards-mo~b682605c",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-base-base-module",
		"common",
		"views-base-base-module"
	],
	"./views/buttons/buttons.module": [
		"./src/app/views/buttons/buttons.module.ts",
		"views-buttons-buttons-module"
	],
	"./views/chartjs/chartjs.module": [
		"./src/app/views/chartjs/chartjs.module.ts",
		"views-chartjs-chartjs-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-dashboard-dashboard-~f8b7fa5d",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/editors/editors.module": [
		"./src/app/views/editors/editors.module.ts",
		"views-editors-editors-module"
	],
	"./views/forms/forms.module": [
		"./src/app/views/forms/forms.module.ts",
		"views-forms-forms-module"
	],
	"./views/google-maps/google-maps.module": [
		"./src/app/views/google-maps/google-maps.module.ts",
		"views-google-maps-google-maps-module"
	],
	"./views/icons/icons.module": [
		"./src/app/views/icons/icons.module.ts",
		"views-icons-icons-module"
	],
	"./views/notifications/notifications.module": [
		"./src/app/views/notifications/notifications.module.ts",
		"default~advanced-forms-advanced-forms-module~dashboards-dashboards-module~views-notifications-notifi~51f09f6f",
		"common",
		"views-notifications-notifications-module"
	],
	"./views/plugins/plugins.module": [
		"./src/app/views/plugins/plugins.module.ts",
		"views-plugins-plugins-module"
	],
	"./views/tables/tables.module": [
		"./src/app/views/tables/tables.module.ts",
		"views-tables-tables-module"
	],
	"./views/theme/theme.module": [
		"./src/app/views/theme/theme.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-theme-theme-module"
	],
	"./views/widgets/widgets.module": [
		"./src/app/views/widgets/widgets.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;